import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'batchConfig.title',
    defaultMessage: 'Configuration',
    description: 'Title of the batch configuration section',
  },
};

export default defineMessages(translations);
